(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Push sold-out products to the bottom
  function sortBySoldOutStatus() {
    const productGrid = document.querySelector('.product-grid__list');
    
    if (!productGrid) return;
    
    const products = Array.from(productGrid.querySelectorAll('.product-grid__item'));
    
    // Separate in-stock and out-of-stock
    const inStock = products.filter(product => 
      !product.querySelector('.badge--sold-out, .sold-out, [data-available="false"]')
    );
    const outOfStock = products.filter(product => 
      product.querySelector('.badge--sold-out, .sold-out, [data-available="false"]')
    );
    
    // Re-append in order: in-stock first, then out-of-stock
    [...inStock, ...outOfStock].forEach(product => productGrid.appendChild(product));
  }
  
  // Run on initial load
  document.addEventListener('DOMContentLoaded', sortBySoldOutStatus);
  
  // Re-run after filtering/sorting (Horizon uses custom events)
  document.addEventListener('results-list:updated', sortBySoldOutStatus);

  // Magic Filters Integration - Product Grid Updater
  document.addEventListener('magic-filters:updated', (e) => {
    const filteredProducts = e.detail.products;
    updateProductGrid(filteredProducts);
  });
  
  function updateProductGrid(products) {
    const grid = document.querySelector('.product-grid__list');
    if (!grid) return;
    
    // Hide all products first
    const allItems = grid.querySelectorAll('.product-grid__item');
    allItems.forEach(item => {
      item.style.display = 'none';
    });
    
    // Show only filtered products
    products.forEach(product => {
      const item = grid.querySelector(`[data-product-id="${product.id}"]`);
      if (item) {
        item.style.display = '';
      }
    });
    
    // Update "no results" message
    const visibleCount = products.length;
    showNoResultsMessage(visibleCount === 0);
    
    // Re-run sold-out sorting on filtered products
    sortBySoldOutStatus();
  }
  
  function showNoResultsMessage(show) {
    let noResults = document.querySelector('.magic-no-results');
    
    if (show && !noResults) {
      noResults = document.createElement('div');
      noResults.className = 'magic-no-results';
      noResults.style.cssText = `
        grid-column: 1 / -1;
        text-align: center;
        padding: 60px 20px;
        color: var(--color-foreground);
      `;
      noResults.innerHTML = `
        <h3 style="margin-bottom: 10px; font-size: 24px;">No cards found</h3>
        <p style="color: rgba(255, 255, 255, 0.6);">Try adjusting your filters</p>
      `;
      
      const grid = document.querySelector('.product-grid__list');
      if (grid) grid.appendChild(noResults);
    } else if (!show && noResults) {
      noResults.remove();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
